import React from "react"
import Button from "react-bootstrap/Button"
import Container from "react-bootstrap/Container"
import { Trans } from "react-i18next"
import { CenterLayout } from "../../presentationals/layouts/center"

import styles from "./not-found.module.scss"

class NotFound extends React.Component {
    render(): JSX.Element {
        return (
            <CenterLayout>
                <Container className={styles.notFound}>
                    <h1>
                        <Trans>generic.page_not_found</Trans>
                    </h1>

                    <Button onClick={() => window.history.back()}>Back</Button>
                </Container>
            </CenterLayout>
        )
    }
}

export default NotFound
